import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsService } from 'army-builder-shared';

@Component({
    standalone: false,
    selector: 'fww-settings',
    template: `
        <abs-page-layout
            title="Settings"
            *ngLet="{
                loginState: settingsService.login$ | async,
                settings: this.settingsService.settings$ | async
            } as props"
        >
            <div class="content">
                <div *ngIf="props.loginState.user" class="account">
                    <!-- <p class="content">
                    {{ 'GLOBAL.LOGIN.LOGGED_IN_MESSAGE' | translate: props.loginState.user }}
                </p>
                <div class="buttons">
                    <ion-button [routerLink]="['user']">{{ 'GLOBAL.MENU_ITEMS.USER' | translate }}</ion-button>
                </div> -->

                    <fww-user></fww-user>
                    <!-- <fww-manage-subscription></fww-manage-subscription> -->
                </div>
                <abs-devices></abs-devices>

                <h2>Fallout: Wasteland Warfare</h2>
                <abs-settings [gameId]="'fww'"></abs-settings>

                <h2>Fallout: Factions</h2>
                <abs-settings [gameId]="'ff'"></abs-settings>

                <div class="buttons">
                    <ion-button [routerLink]="['debug']" [relativeTo]="this.route">{{
                        'GLOBAL.SETTINGS.DEBUG.TITLE' | translate
                    }}</ion-button>
                </div>
            </div>
        </abs-page-layout>
    `
})
export class SettingsPage {
    constructor(
        public settingsService: SettingsService,
        protected route: ActivatedRoute
    ) {}
}
